import { base } from "motion/react-m"

//export const baseURL= "http://192.168.29.250:7003/api/"
export const baseURL= "https://doctor-service.swasthyakhata.com/api/"

export const auth={
    checkUserByAdhaar:baseURL+'doctor/checkUserByAadhaar',
    sendOtp:baseURL+'doctor/send-otp',
    loginDoctor:baseURL+'doctor/login',
    createDoctor:baseURL+'doctor/create',
    getprofile:baseURL+'doctor/get-doctor-profile'
}

// NEW
export const doctor = {
    getAllHospitals: baseURL + 'doctor/get-all-hospitals-for-doctor',
      getAllDiagnocs: baseURL + 'doctor/get-all-diagnostic-centers-for-doctor',
    createDoctorHospitalMapping: baseURL + 'doctor/create-doctor-hospital-mapping',
    requestDoctorHospitalMapping:baseURL+'doctor/request-doctor-hospital-mapping',
    getHospitalRequests:baseURL+'doctor/mapping-requests-from-hospitals',
     getDiagnosticRequests:baseURL+'doctor/mapping-requests-from-diagnostic-centers',
     approaveHospitalRequest:baseURL+'doctor/hospital-request-doctor-mapping/approve-reject'
}

export const patient={
    checkMap:baseURL+'doctor/patient-mapping-check',
    getmappedPatient:baseURL+'doctor/get-mapped-patient',
    patientMappingOtpSend:baseURL+'doctor/send-otp-for-patient-mapping',
    createmAPPINGvERIFY:baseURL+'doctor/create-patient-mapping',
    uploadReport:baseURL+'doctor/upload-report-by-doctor'
}